
import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

function Popover({ children, content, fontSize = '10px' }) {
  const [isHovered, setIsHovered] = useState(false);
  const timerRef = useRef(null);
  const containerRef = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(timerRef.current);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => setIsHovered(false), 200);
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={containerRef}
    >
      <span style={{ cursor: 'pointer' }}>{children}</span>
      {isHovered &&
        ReactDOM.createPortal(
          <div
            style={{
              position: 'fixed',
              top: (containerRef.current?.getBoundingClientRect().bottom || 0) + 5,
              left: containerRef.current?.getBoundingClientRect().left || 0,
              background: '#fff',
              border: '1px solid #ccc',
              borderRadius: '3px',
              padding: '0px 5px 2px 2px',
              zIndex: 9999,
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              whiteSpace: 'nowrap',
              fontSize, maxHeight: '200px',
              overflowY: 'auto'
            }}
          >
            {content}
          </div>,
          document.body
        )}
    </div>
  );
}

export default Popover;

// import React, { useState, useRef } from 'react';

// function Popover({ children, content }) {
//   const [isHovered, setIsHovered] = useState(false);
//   const timerRef = useRef(null);

//   const handleMouseEnter = () => {
//     clearTimeout(timerRef.current);
//     setIsHovered(true);
//   };

//   const handleMouseLeave = () => {
//     timerRef.current = setTimeout(() => setIsHovered(false), 200);
//   };

//   return (
//     <div
//       style={{ position: 'relative', display: 'inline-block' }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       <span style={{ cursor: 'pointer' }}>
//         {children}
//       </span>
//       {isHovered && (
//         <div
//           style={{
//             position: 'fixed', // ⬅️ fixed to viewport
//             top: (containerRef.current?.getBoundingClientRect().bottom || 0) + 5,
//             left: containerRef.current?.getBoundingClientRect().left || 0,
//             background: '#fff',
//             border: '1px solid #ccc',
//             borderRadius: '6px',
//             padding: '10px',
//             zIndex: 9999,
//             boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//             whiteSpace: 'nowrap',
//           }}
//         >
//           {content}
//         </div>
//       )}
//     </div>
//   );
// }

// export default Popover;
